export default __webpack_public_path__ + "static/media/401_Error_Message.30049c0b.png";